import { createApi } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import {
  createPaymentAccountShape,
  paymentAccountFiltersShape,
  paymentAccountShape,
} from './models'

export const paymentAccountApi = createApi({
  client: axiosInstance,
  baseUri: '/expenses/payment-accounts/',
  models: {
    entity: paymentAccountShape,
    create: createPaymentAccountShape,
    extraFilters: paymentAccountFiltersShape,
  },
})
